import React from 'react';
import {TableHeader, TableRow, FieldName, FieldData, FullWidthCell } from "../../Components/DashboardTable";
import { BookingType } from '../../Components/Types';
import { ConvertToPounds, getDaysArray } from '../../Components/Functions';
import moment from 'moment';
import Button  from '../../Components/Button';
import { useMsal } from '@azure/msal-react';
import { BookingAPI } from 'API/BookingAPI';
import { toast } from 'react-toastify';
import { toastConfig } from 'Components/Constants';

type MyBookingsProps = {
    bookings: BookingType[][];
    visiblePage: number;
    licenseCheck: (bookingId: number) => void;
    bookingPayments: (bookingId: number, vehicleName: string) => void;
}
function DesktopBookingTable({ bookings, visiblePage, licenseCheck, bookingPayments }: MyBookingsProps) {
    const { instance } = useMsal();
    
    const cancelBooking = async (bookingId: number) => {
        const response = await BookingAPI.cancel(instance, bookingId);
        toast.success(response, { ...toastConfig, toastId: response + "-toast" });
    }

    return (
        <>
            <TableHeader>
                <tr>
                    <FieldName>Reference</FieldName>
                    <FieldName>Vehicle</FieldName>
                    <FieldName>Regmark</FieldName>
                    <FieldName>Duration (days)</FieldName>
                    <FieldName>Cost</FieldName>
                    <FieldName>Collection Date</FieldName>
                    <FieldName>Return Date</FieldName>
                    <FieldName>Driving Licence Check</FieldName>
                </tr>
            </TableHeader>
            <tbody>
            {bookings.length > 0 ?
                bookings[visiblePage].map((booking: BookingType) => {
                const startDate = moment(booking.start_date.split('T')[0]);
                const endDate = moment(booking.end_date.split('T')[0]);
                const duration = getDaysArray(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')).length;
                return (
                    <TableRow key={booking.booking_id}>
                        <FieldData>{booking.booking_id}</FieldData>
                        <FieldData>{booking.vehicle_name}</FieldData>
                        <FieldData>{booking.regmark}</FieldData>
                        <FieldData>{duration}</FieldData>
                        <FieldData>{ConvertToPounds(booking.total_cost)}</FieldData>
                        <FieldData>{startDate.format('DD MMM YYYY')}</FieldData>
                        <FieldData>{endDate.format('DD MMM YYYY')}</FieldData>
                        <FieldData>
                            {booking.mandate_status_description == "N/A" ?
                                booking.mandate_status_description :
                                <Button
                                    type="button"
                                    text={booking.mandate_status_description}
                                    colour="dark"
                                    onClick={() => booking.mandate_status < 3 && licenseCheck(booking.booking_id)}
                                    disabled={booking.mandate_status > 2}
                                />
                            }
                            
                        </FieldData>
                        <FieldData>
                            <Button
                                type="button"
                                text="payments"
                                colour="dark"
                                onClick={() => bookingPayments(booking.booking_id, booking.vehicle_name)}
                            />
                        </FieldData>
                        <FieldData>
                        {startDate.isAfter() &&
                            <Button
                                type="button"
                                text="cancel"
                                colour="dark"
                                onClick={() => cancelBooking(booking.booking_id)}
                            />
                        }
                        </FieldData>
                    </TableRow>
                );
                }) :
                <tr>
                    <FullWidthCell colSpan={100}>No bookings found.</FullWidthCell>
                </tr>
            }
            </tbody>
        </>
    );
}
export default DesktopBookingTable;
